import sliceCreator from '../../index.js';
import {EDIT_RAW_MATERIAL} from '../../../constants/index.js';
const _editRawMaterialAction = sliceCreator('EDIT_RAW_MATERIAL', EDIT_RAW_MATERIAL, 'put');

const { asyncAction: editRawMaterialAction, reducer, clearData: clearEditRawMaterialAction } = _editRawMaterialAction;

export default reducer;

export {
    editRawMaterialAction,
    clearEditRawMaterialAction
}